export default __webpack_public_path__ + "static/media/TopBarStoreLogo.6963555f.svg";